import { motion } from "framer-motion";

export type TemplateInformationOverlay = {
    assistantLabel: string;
    message: string;
    multiChainText: string;
}

export default function TemplateInformationOverlay({ overlay }: { overlay: TemplateInformationOverlay }) {
    return (
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent rounded-2xl flex items-end">
            <div className="p-6 text-white">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 1.2, ease: "easeOut" }}
                    className="space-y-2 text-left"
                >
                    <div className="flex items-center gap-2 md:mb-2">
                        <div className="size-2 bg-green-400 rounded-full animate-pulse"></div>
                        <span className="text-[10px] md:text-sm font-medium">{overlay.assistantLabel}</span>
                    </div>
                    <p className="text-[10px] md:text-sm opacity-90">{overlay.message}</p>
                    <div className="flex items-center gap-2 mt-3">
                        <div className="flex -space-x-1">
                            <div className="size-4 bg-blue-500 rounded-full border-2 border-white"></div>
                            <div className="size-4 bg-purple-500 rounded-full border-2 border-white"></div>
                            <div className="size-4 bg-green-500 rounded-full border-2 border-white"></div>
                        </div>
                        <span className="text-[11px] opacity-75">{overlay.multiChainText}</span>
                    </div>
                </motion.div>
            </div>
        </div>
    )
}